import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

import { NgModule, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { TitleStrategy } from '@angular/router';
import { AppTitleStrategy } from './shared/services/title.strategy';
import { AppComponent } from './app.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { NewShellComponent } from './layouts/new-shell/new-shell.component';
import { AuthModule } from './features/auth/auth.module';
import { NavModule } from './features/nav/nav.module';
import { metaReducers, reducers } from './state/app.reducer';
import {
  provideNamedApollo,
  NamedOptions,
} from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache } from '@apollo/client/core';
import { CommonModule as ngCommonModule } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './shared/shared.module';
import { LoaderInterceptor } from './shared/services/loader.interceptor';
import { LoaderComponent } from './shared/component/loader/loader.component';
import { provideMarkdown } from 'ngx-markdown';
import { FeatureAnnouncementModalComponent } from './shared/components/feature-announcement-modal/feature-announcement-modal.component';
import { HelpPanelComponent } from './shared/components/help-panel/help-panel.component';
//import { TournamentactivesubscriptionComponent } from './tournamentactivesubscription/tournamentactivesubscription.component';
//import { SchoolsessionactivesubscriptionComponent } from './features/dashboard/dashboard/schoolsessionactivesubscription/schoolsessionactivesubscription.component';
//import { HolidaycampactivesubscriptionsComponent } from './holidaycampactivesubscriptions/holidaycampactivesubscriptions.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthLayoutComponent,
    MainLayoutComponent,
    //TournamentactivesubscriptionComponent,
    //SchoolsessionactivesubscriptionComponent,
    //HolidaycampactivesubscriptionsComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AuthModule.forRoot(),
    StoreModule.forRoot(reducers, {
      metaReducers,
    }),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    }),
    NavModule,
    EffectsModule.forRoot([]),
    ToastrModule.forRoot(),
    ngCommonModule,
    SharedModule,
    LoaderComponent,
    FeatureAnnouncementModalComponent,
    HelpPanelComponent,
    NewShellComponent,
  ],
  providers: [
    provideMarkdown(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '.dark-mode, [data-theme="dark"]',
          cssLayer: {
            name: 'primeng',
            order: 'primeng',
          },
        },
      },
    }),
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: TitleStrategy, useClass: AppTitleStrategy },
    provideNamedApollo(() => {
      const httpLink = inject(HttpLink);
      return {
        gqlActivityPro: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.api.graphql,
          }),
        },
        gqlActivityProNew: {
          cache: new InMemoryCache(),
          link: httpLink.create({
            uri: environment.api.graphqlNew,
          }),
        },
      };
    }),
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
